import {
  EUsersViewActions,
  UsersViewActions,
} from '@myStore/users-view/users-view.actions';
import {
  initialsUsersViewState,
  IUsersViewState,
} from '@myStore/users-view/users-view.state';

export const usersViewReducers = (
  state = initialsUsersViewState,
  actions: UsersViewActions
): IUsersViewState => {
  switch (actions.type) {
    case EUsersViewActions.GetUsersRequest:
      return {
        ...state,
        users: {
          ...state.users,
          isLoading: true,
        },
      };
    case EUsersViewActions.GetUsersSuccess:
      return {
        ...state,
        users: {
          ...state.users,
          listInfo: actions.payload,
          isLoading: false,
        },
      };
    case EUsersViewActions.GetUsersFailure:
      return {
        ...state,
        users: {
          ...state.users,
          isLoading: false,
          errors: actions.error,
        },
      };
    case EUsersViewActions.ClearUsers:
      return {
        ...state,
        users: {
          ...state.users,
          listInfo: null,
          errors: null,
        },
      };

    case EUsersViewActions.GetStudentsRequest:
      return {
        ...state,
        students: {
          ...state.students,
          isLoading: true,
        },
      };
    case EUsersViewActions.GetStudentsSuccess:
      return {
        ...state,
        students: {
          ...state.students,
          listInfo: actions.students,
          isLoading: false,
        },
      };
    case EUsersViewActions.GetStudentsFailure:
      return {
        ...state,
        students: {
          ...state.students,
          isLoading: false,
          errors: actions.error,
        },
      };

    case EUsersViewActions.ClearStudents:
      return {
        ...state,
        students: {
          ...state.students,
          listInfo: null,
          errors: null,
        },
      };

    case EUsersViewActions.GetTeachersRequest:
      return {
        ...state,
        teachers: {
          ...state.teachers,
          isLoading: true,
        },
      };
    case EUsersViewActions.GetTeachersSuccess:
      return {
        ...state,
        teachers: {
          ...state.teachers,
          listInfo: actions.teachers,
          isLoading: false,
        },
      };
    case EUsersViewActions.GetTeachersFailure:
      return {
        ...state,
        teachers: {
          ...state.teachers,
          isLoading: false,
          errors: actions.error,
        },
      };

    case EUsersViewActions.ClearTeachers:
      return {
        ...state,
        teachers: {
          ...state.teachers,
          listInfo: null,
          errors: null,
        },
      };

    case EUsersViewActions.GetUserNoteByIdRequest:
      return { ...state, notes: { ...state.notes, isLoading: true } };
    case EUsersViewActions.GetUserNoteByIdSuccess:
      return {
        ...state,
        notes: { ...state.notes, detail: actions.payload, isLoading: false },
      };
    case EUsersViewActions.GetUserNoteByIdFailure:
      return {
        ...state,
        notes: { ...state.notes, isLoading: false, errors: actions.errors },
      };
    case EUsersViewActions.ClearGetUserNoteById:
      return {
        ...state,
        notes: { ...state.notes, detail: null, errors: null },
      };

    case EUsersViewActions.GetUsersNotesRequest:
      return { ...state, notes: { ...state.notes, isLoading: true } };
    case EUsersViewActions.GetUsersNotesSuccess:
      return {
        ...state,
        notes: { ...state.notes, listInfo: actions.payload, isLoading: false },
      };
    case EUsersViewActions.GetUsersNotesFailure:
      return {
        ...state,
        notes: { ...state.notes, isLoading: false, errors: actions.error },
      };
    case EUsersViewActions.ClearUsersNotes:
      return {
        ...state,
        notes: { ...state.notes, listInfo: [], errors: null },
      };

    case EUsersViewActions.GetStudentGroupsResultsRequest:
      return {
        ...state,
        groupsResults: { ...state.groupsResults, isLoading: true },
      };
    case EUsersViewActions.GetStudentGroupsResultsSuccess:
      return {
        ...state,
        groupsResults: {
          ...state.groupsResults,
          isLoading: false,
          results: actions.payload,
        },
      };
    case EUsersViewActions.GetStudentGroupsResultsFailure:
      return {
        ...state,
        groupsResults: {
          ...state.groupsResults,
          isLoading: false,
          errors: actions.errors,
        },
      };
    case EUsersViewActions.ClearStudentGroupsResults:
      return {
        ...state,
        groupsResults: {
          ...state.groupsResults,
          isLoading: false,
          errors: null,
          results: [],
        },
      };

    case EUsersViewActions.GenerateStudentResultsRequest:
      return {
        ...state,
        finalGenerateResults: {
          ...state.finalGenerateResults,
          isLoading: true,
        },
      };
    case EUsersViewActions.GenerateStudentResultsSuccess:
      return {
        ...state,
        finalGenerateResults: {
          ...state.finalGenerateResults,
          isLoading: false,
          results: actions.payload,
        },
      };
    case EUsersViewActions.GenerateStudentResultsFailure:
      return {
        ...state,
        finalGenerateResults: {
          ...state.finalGenerateResults,
          isLoading: false,
          errors: actions.errors,
        },
      };
    case EUsersViewActions.ClearGenerateStudentResults:
      return {
        ...state,
        finalGenerateResults: {
          ...state.finalGenerateResults,
          isLoading: false,
          errors: null,
          results: null,
        },
      };

    case EUsersViewActions.GetStudentFinalResultsRequest:
      return {
        ...state,
        finalResults: { ...state.finalResults, isLoading: true },
      };
    case EUsersViewActions.GetStudentFinalResultsSuccess:
      return {
        ...state,
        finalResults: {
          ...state.finalResults,
          isLoading: false,
          results: actions.payload,
        },
      };
    case EUsersViewActions.GetStudentFinalResultsFailure:
      return {
        ...state,
        finalResults: {
          ...state.finalResults,
          isLoading: false,
          errors: actions.errors,
        },
      };
    case EUsersViewActions.ClearStudentFinalResults:
      return {
        ...state,
        finalResults: {
          ...state.finalResults,
          isLoading: false,
          errors: null,
          results: [],
        },
      };
    default:
      return state;
  }
};
